import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Box, Typography, styled } from '@mui/material';
import { useCallback } from 'react';
import type { FC } from 'react';

import CustomCheckbox from 'components/MuiCustom/CustomCheckbox';

import type { OrganizationMembersDatabase } from 'redux-store/slices/organizationOverview/types';

export interface MemberListProps {
  member: OrganizationMembersDatabase;
  selectedMembers: number[];
  organizationId: number | null;
  deviceId: number | null;
  userId: number | null;
  setSelectedMembers: (member: number[]) => void;
}

const CustomBox = styled(Box)(({ theme }) => ({
  '&:not(:first-of-type)': {
    borderTop: `1px solid ${theme.vars.palette.grey[100]}`,
  },
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: theme.spacing(1),
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  cursor: 'pointer',
}));

const MemberList: FC<MemberListProps> = ({
  member,
  selectedMembers,
  setSelectedMembers,
}) => {
  const handleCheckboxChange = useCallback(() => {
    if (selectedMembers.includes(member.id)) {
      setSelectedMembers(selectedMembers.filter(id => id !== member.id));
    } else {
      setSelectedMembers([...selectedMembers, member.id]);
    }
  }, [member.id, selectedMembers, setSelectedMembers]);

  return (
    <CustomBox onClick={handleCheckboxChange}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          gap={1}
          data-testid={`member-row-${member.id}`}
        >
          <CustomCheckbox
            checked={selectedMembers.includes(member.id)}
            onChange={handleCheckboxChange}
            data-testid="select-member-checkbox"
          />
          <Box display="flex" flexDirection="row" gap={1}>
            <PersonOutlineOutlinedIcon />
            <Typography data-testid="member-email">{member.email}</Typography>
          </Box>
        </Box>
      </Box>
    </CustomBox>
  );
};

export default MemberList;
